import { ZervantSettings } from '../types/zervantSettings'
import { parseLegalStatus } from './parseLegalStatus'

export const getDefaultLegalStatusValues = (zervantSettings: ZervantSettings | undefined) => {
  const sharedCapital = zervantSettings?.values.company.legalFormSettings?.sharedCapital || undefined
  const legalStatusData = parseLegalStatus(zervantSettings?.values.company.legalStatus)

  return {
    ...legalStatusData,
    sharedCapital,
  }
}
